import React, { useEffect, useState } from 'react';
import type { RouteComponentProps } from 'react-router-dom';
import { useAdminDispatch } from 'admin/reducers';
import { Error } from 'admin/components/common/Form';
import { postGoogleCallback } from 'admin/actions/integrations';
import { notifyGoogleOAuthCallback } from './googleOAuthBridge';

export { listenGoogleOAuthCallback } from './googleOAuthBridge';
export type { GoogleOAuthCallbackPayload } from './googleOAuthBridge';

const GoogleOAuth: React.FC<RouteComponentProps> = () => {
	const [error, setError] = useState<string | null>(null);
	const dispatch = useAdminDispatch();

	useEffect(() => {
		const url = new URL(window.location.href);
		const state = url.searchParams.get('state');
		const code = url.searchParams.get('code');

		if (code && state) {
			dispatch(postGoogleCallback({ code, state })).then(({ errors }) => {
				if (errors?.length) {
					setError(errors[0].message);
				} else {
					notifyGoogleOAuthCallback({ code, state });
					window.close();
				}
			});
		} else {
			setError('Missing data.');
		}
	}, [dispatch]);

	return error ? <Error>{error}</Error> : null;
};

export default GoogleOAuth;
